// extracted by mini-css-extract-plugin
export default {"payload":"WebhookMonitor_payload__aocYz"};